import { useContext } from "react";
import {
  CreateWorkspaceLoaderContext,
  CreateWorkspaceLoaderContextType,
} from "./CreateWorkspaceLoaderContext";

export const useCreateWorkspaceLoader =
  (): CreateWorkspaceLoaderContextType => {
    const context = useContext(CreateWorkspaceLoaderContext);
    if (!context) {
      throw new Error(
        "useCreateWorkspaceLoader must be used within a CreateWorkspaceLoaderProvider"
      );
    }
    return context;
  };
